import instance from '@/utils/axios';

/**
 * 飞行任务列表
 * @returns
 */
export function flightMissionListServer(data) {
  return instance.post('/flightMission/findList', data);
}

/**
 * 保存飞行任务
 * @param {*} data
 * data.name  任务名称
 * data.pointName 地点
 * data.beginTime 开始时间
 * data.endTime 结束时间
 * data.remarks 任务描述
 *
 * @returns
 */
export function saveFlightTaskServer(data) {
  return instance.post('/flightMission/save', data);
}

/**
 * 删除飞行任务
 * @param {*} data
 * @returns
 */
export function deleteFlightTaskServer(data) {
  return instance.post('/flightMission/remove', data);
}

/**
 * 执行飞行任务
 * @param {*} data
 * data.flightStartTime 开始时间
 * data.flightEndTime 结束时间
 * data.flightMissionId 任务id
 * data.remarks 备注
 * data.sn 设备sn
 * data.id
 * @returns
 */
export function saveFlightRecordServer(data) {
  return instance.post('flightMissionRecord/save', data);
}

/**
 * 飞行记录列表
 * @param {*} data
 * data.flightMissionId  任务id
 * @returns
 */
export function flightRecoreListServer(data) {
  return instance.post('flightMissionRecord/findList', data);
}

/**
 * 删除飞行记录
 * @param {*} data
 * data.id
 * @returns
 */
export function deleteFlightMissionRecord(data) {
  return instance.post('flightMissionRecord/remove', data);
}

/**
 * 更新飞行任务
 * @param {*} data
 * data.flightStartTime 开始时间
 * data.flightEndTime 结束时间
 * data.flightMissionId 任务id
 * data.remarks 备注
 * data.sn 设备sn
 * data.id
 * @returns
 */
export function updateFlightRecordServer(data) {
  return instance.post('flightMissionRecord/update', data);
}
